export default {
  productList: '管理商品',
  listingId: 'Listing 编号',
  SKU_productId: 'SKU 编号',
  title: '标题',
  showCountry: '展示国家',
  baseStation: '基站',
  expand: '扩展',
  options: '选项',
  expanded: '已扩展',
  unExpanded: '未扩展',
  all: '所有',
  category: '品类',
  addTime: '添加时间',
  thisMonth: '当月',
  today: '当日',
  online: '在线付款',
  offline: '货到付款',
  prePay: '预付',
  all2: '所有',
  resetFilter: '重置',
  setPaymentMethod: '设置支付方式',
  supportOnlinePay1: '商品所在仓库默认都支持Online Pay，系统对于商品所支持的支付方式由 商品本身的支付方式 + 所在仓库所支持的支付方式 合并产生，所以对商品设置时一般无需额外再设置支持Online Pay。同时，由于批量操作针对的是Listing，那么当设置后Listing下所有的SKU都支持所设置的支付方式。',
  supportOnlinePay2: '由于批量选择的商品可能不在同一个仓库，所以在批量设置中暂时无法展示每一个商品当前所支持的支付方式。',
  supportOnlinePay3: ' 您将设置所选中的这些商品支付以下支付方式(支持请打勾)',
  COD: 'COD',
  selectAll: '全选',
  setActive: '上架',
  setInactive: '下架',
  applyActive: '申请上架',
  applyActiveDisabledTitle: '暂不可申请上架',
  violationCountTip: '该商品第 {0} 次违规下架',
  coolDownRemainTip: '等待期剩余 {0} 天',
  applyAvailableTip: '预计 {0} 后可申请',
  qcCoolingOffTag: '等待期：剩余 {0} 天后可申请上架',
  qcRelistableTag: '等待期已满，可申请上架',
  setPay: '支付方式',
  exportExcel: '导出商品',
  chooseCategory: '选择类目',
  cat: '类目ID',
  priceMin: '最低商品价',
  priceMax: '最高商品价',
  skuCount: 'SKU数',
  status: '状态',
  weight: '重量(g)',
  operation: '操作',
  leastPay: '请至少设置 一个支付方式！',
  confirmPaymethod1: '您确认要将选中的商品',
  confirmPaymethod2: '不支持 ',
  confirmPaymethod3: '吗？',
  confirmPaymethod4: '支持 ',
  batchInactiveGoods: '你是否确认下架选中的{0}个商品?',
  batchActiveGoods: '你是否确认上架选中的{0}个商品? ',
  whetherDelete: '是否要删除选中的商品？',
  batchOperation: '批量操作',
  // S349
  categoryStore: '店内分类',
  storeCategory: '店铺品类',
  okText: '确定',
  moveSure: '您确定将这些商品移动到分类',
  // 当前共选择{{ listingIds.length }}个商品，分属{{catelistNum}}个店内分类
  categoriesTotal1: '共',
  categoriesTotal2: '个商品被选择',
  categoriesTotal3: '分属',
  categoriesTotal4: '个店内分类',
  batchPrice: '批量改价',
  limitPriceChange: '每日仅限2次改价，每次改价执行耗时几十秒到几十分钟不等',
  reminderOfTimesLimit: '您本次不能批量修改价格，因为您今天的修改次数达到了上限。',
  exportProducts: '导出文件',
  stepOne: '步骤一',
  stepTwo: '步骤二',
  // allProducts: '所有商品',
  // saleProducts: '销售中商品',
  // exportTemplate: '导出模板',
  UploadFiles: '上传文件',
  SelectFiles: '选择文件',
  batchPriceCancel: '取消',
  selectCountry: '请先选择国家',
  batchPriceSubmit: '提交',
  violationStatus: '违规下架',
  normal: '未违规下架',
  violation: '已违规下架',
  infoScore: '信息质量分',
  thisProductScore: '该商品信息质量分为 {0}',
  thereRecommended1: '有',
  thereRecommended2: '项优化建议:',
  scoreTitleOptimize: '完善商品标题长度',
  scoreCarouselOptimize: '上传更多商品轮播主图',
  scoreVideoOptimize: '上传商品主视频',
  scoreAttributeOptimize: '完善商品属性信息',
  scoreDetailOptimize: '完善或丰富详情描述的文案和图片',
  scoreWhiteOptimize: '上传商品白底图',
  optimizeNow: '立即优化',
  active: '上架',
  inactive: '下架',
  qcReject: '已违规下架',
  qcWarning: '质控预警',
  qcLocked: '已违规锁定',
  pendingQC: '等待质控审核',
  removed: '已删除',
  unexpanded: '未扩展',
  supportedShippingType: '支持的物流方式',
  agentProduct: '是否是代理商品',
  vendorProductID: '供应商货号',
  countrySite: '国家站',
  expandAndCollapse: '扩展/折叠',
  productName: '商品名称',
  priceRange: '价格区间',
  fbkStock: 'FBK库存',
  fbk: 'FBK',
  ds: 'DS',
  gs: 'GS',
  yes: '是',
  no: '否',
  pleaseSelect: '请选择',
  basicSite: '基站',
  creationDate: '商品创建时间',
  r30Sold: 'R30 Sold',
  inventory: '库存',
  removeDate: '移除时间',
  skus: 'SKUs',
  latestViolationReason: '最近违规下架原因',
  applyActivation: '申请上架',
  remove: '删除',
  max: '最大',
  min: '最小',
  brand: '品牌',
  addProduct: '添加商品',
  skuImage: 'SKU缩略图',
  variant: '规格',
  marketReferencePrice: '市场参考价',
  sellingPrice: '销售价',
  collapse: '折叠',
  expandIcon: '扩展',
  multiValue: '支持多值',
  support: '支持',
  noSupport: '不支持',
  paymentMethodNote: '注意：设置仅应用于选中的{0}个商品层级上.',
  confirm: '确认',
  moveTheSelect: '将选中的{0}个商品移动到',
  removeNote: '你是否确认删除选中的{0}个商品?',
  applyActivationNote1: '你是否确认将选中的{0}个商品进行申请上架?',
  activatedForSale: '正常上架，可销售',
  notActivatedForSale: '正常下架，不可销售',
  pendingPlatformReview: '等待平台审核，不可销售',
  inactivatedPlatformViolation: '被平台进行违规下架处理，不可销售，可申请重新上架销售',
  qcWarningTip: '潜在违规预警，商品仍可购买。请优化商品信息以避免违规。',
  lockedTip: '被平台进行违规下架处理，不可销售，不可申请重新上架销售，若需上架请自行联系商家客服',
  removedTip: '被删除，不可销售',
  unexpandedTip: '未设置过本国家站的销售价格的商品，不可销售。设置价格后自动上架销售',
  duplicate: '复制',
  nonFbk: '非FBK库存',
  nonFbkAvail: '非FBK库存(可用)',
  fbkaAvail: 'FBK(可用)',
  fold: '折叠',
  more: '展开',
  totalAvailableInv: '总可用库存',
  createDate: '创建时间',
  updateDate: ' 更新时间',
  supportedFulfillType: '支持的履约类型',
  newProduct: '新增商品',
  productInfo: '商品信息',
  price: '售价',
  optimizedNum: '{0} 处须优化',
  delete: '删除',
  violationReason: '违规原因',
  viewWarningReason: '预警原因',
  edit: '编辑',
  rating: '评分',
  scoreTip: '商品信息质量分满分为100分，评判商品信息填写的完整度。分数越高越优秀。',
  vendorProductId: '供应商货号',
  clearFilter: '清空筛选',
  batchApply: '批量应用',
  nonFbkInventory: '可用非FBK库存',
  editPrice: ' 编辑价格',
  editInventory: ' 编辑库存',
  totalInventory: '总库存',
  lockedInventory: '已锁定库存',
  availableInventory: '可用库存',
  lockedInventoryTip: '包含未取消的订单上的商品件数，或参与促销活动（如秒杀）承诺的库存数。当订单取消或活动结束时，未消耗的件数将会释放变为可用库存。',
  availableInventoryTip: '未锁定的库存，可以用于常规销售活动。当设置为0时，商品在非促销频道中立即变为不可售卖，但之前锁定的库存可能会返回成可用库存，所以如果您实际已经缺货的情况下，建议将该 SKU 下架。',
  statusTip: '表示SKU的可售状态。',
  mustBeGreaterSelling: '市场参考价必须大于售价',
  mustBeLessMarket: '售价必须小于市场参考价',
  notEmpty: '不能为空',
  mustGreaterZero: '必须大于0',
  conNotLessZero: '不能小于0',
  mustInteger: '必须是整数',
  inputFilterPlaceholder: '规格 /SKU编号 /供应商货号',
  downloadTemplate: '下载模板',
  someVariantsPriceClear: '某些SKU的价格设置不合规，请清空筛选条件后检查。',
  someInventoryClear: '某些SKU的库存设置不合规，请清空筛选条件后检查。',
  allProductExcept: '包含所有商品，但已删除的和未扩展的除外',
  deleted: '删除',
  pleaseSelectBrand: '请先选择品牌',
  handlerSuccess: '操作成功',
  alrightIamAware: '好的，我已知晓',
  back: '返回',
  supportFbk: '支持FBK',
  noSupportFbk: '不支持FBK',
  successfullyCopied: '复制成功',
  thisActiveGoods: '您是否确认要上架该商品?',
  thisInactiveGoods: '您是否确认要下架该商品?',
  applyActiveOnly: '你是否确认要申请上架该商品？',
  deleteGoodsOnly: '你是否确认要删除该商品？',
  quality: '质保',
  goodsQualitySetting: '商品质保设置',
  listingNo: 'Listing #',
  noQuestions: '7天无理由',
  noQuestionsSetCategory: '7天无理由应用平台类目设置',
  noQuestionsInfoPath: '平台7天无理由退货政策和要求>>',
  addedQuestions: '已添加的质保项',
  qualityDeadline: '质保期',
  returnRefundDeadline: '退货退款期',
  exchangeDeadline: '换货期',
  qualityDeadlineTips: '指提供非人为的质量问题的免费售后时长',
  returnRefundDeadlineTips: '指非人为问题的商品质量问题允许用户退货的时长',
  exchangeDeadlineTips: '指非人为问题的商品质量问题允许用户换货的时长',
  addQuestionsItem: '添加质保项',
  save: '保存',
  update: '更新',
  add: '添加',
  confirmAddQualityItem: '您确定要添加此质保项吗?',
  pleaseEnter: '请输入',
  warrantyPeriodBelowCategory: '该周期设置低于品类要求',
  warrantyCategoryMinStandardBanner:
    '平台各品类已设定 {3} 天无理由、退货期({0}天)、换货期({1}天)、质保期({2}天)的强制最低标准。当前商品部分周期设置低于对应品类要求，请调整后重新提交。',
  batchWarrantyCategoryMinStandardTip: '平台各品类已设定 7 天无理由、退货期、换货期、质保期的强制最低标准。你选中的商品中，存在部分商品周期设置不符合对应品类最低要求，请调整后提交。',
  warrantyPrefillHint: '斜体灰字为当前商品所属平台类目配置的默认预填充值。',
  cancel: '取消',
  warrantySetting: '商品质保设置',
  successfully: '操作成功',
  doYouRemoveThis: '您确定要删除此质保项吗?',
  warningReasonTitle: '预警原因：',
  warningReasonSuffix: '，请及时审查并优化相关产品信息和服务流程。如果该指标持续升高，可能会触发平台的进一步处理。',
  customWarrantyOverride: '您的自定义质保设置覆盖平台默认设置。',
  platformDefaultsApply: '如果不添加自定义项，将自动应用平台类目要求。',
  batchSetWarranty: '批量设置质保承诺',
  confirmSettingListings: '该设置将对{0}个商品（包括{1}个SKU）生效',
  batchSetWarrantyInfo: '{0}个商品（包括{1}个SKU）',
  complaintWarnTitle: '预警原因说明：',
  complaintWarnInfringementType: '商标侵权',
  complaintWarnBody1: '该商品被用户投诉侵权，具体侵权原因：',
  complaintWarnBody2: '，如有疑问请在7天内进行申诉，',
  complaintWarnAppealLink: '请点击前往申诉>>>',
  appealDialogTitle: '商品违规申诉',
  appealBanner: '同一商品仅有一次申诉的机会，请确保您上传的资料充足!',
  appealTypeLabel: '申诉类型 *',
  appealBasicLabel: '基础资料 *',
  appealBasicUploadTip: '文件大小需小于 10M，或图片不超过 3 张。',
  appealSupplementLabel: '补充资料（选填）',
  appealReasonLabel: '补充说明（选填）',
  appealSubmit: '提交',
  appealSubmitSuccess: '申诉已提交',
  appealSubmitSuccessTitle: '商品申诉上传成功！',
  appealSubmitSuccessDesc: '请待平台相关负责人审核，审核通过后商品将自动释放；若审核不通过，相关原因将显示在此界面告知。',
  appealRejectedTitle: '商品申诉审核未通过！',
  appealRejectedReasonLabel: '原因：',
  appealRejectedDetailLabel: '详情：',
  appealRejectionReasonUnknown: '其他原因',
  appealResultCloseBtn: '关闭'
}
